module.exports = __webpack_public_path__ + "static/media/02.384d8b78.png";